export default {"icons":{"iconfont":"mdiSvg"},"theme":{"dark":true,"options":{"customProperties":true},"themes":{"dark":{"primary":"#fff","secondary":"#91A5FF","accent":"#51F2B8","error":"#FF3355","background":"#13161A"}}}}
